<ng-container *ngIf="isLoading;else pageContent">
  <div class="app-spinner">
    <mat-spinner></mat-spinner>
  </div>
</ng-container>

<ng-template #pageContent>
  <div class="detailed-solutions-container">
    <div class="header">
      <div class="logo-title" *ngIf="studentResult as studentDetails">
        <img src="assets/images/student_card_2.svg" alt="previous" class="titlelogo me-1" />
        <div class="title-block">
          <h1>{{studentDetails.quiz_name}}</h1>
          <span class="quiz-date">{{convertToIST(studentDetails.published_date || '-')}}</span>
        </div>
      </div>

      <button class="back-button" (click)="goToResultPage()">
        <i class="bi bi-arrow-left"></i> Back to Results</button>
    </div>


    <div class="performance-summary">
      <div class="user-info" *ngIf="studentResult as studentDetails">
        <div class="avatar">{{getUserNameInitials(studentDetails.student_name)}}</div>
        <div class="details">
          <h4>{{studentDetails.student_name || '-'}}</h4>
          <!-- <p>student email</p>-->
        </div>
        <span class="quiz-status">{{studentDetails.status || '-'}}</span>
      </div>

      <h3 class="summary-title">Performance Summary</h3>

      <div class="summary-content">
        <div class="score-circle" *ngIf="studentResult as studentDetails">
          <svg class="progress-ring" viewBox="0 0 140 140">
            <circle class="progress-ring__background" stroke-width="14" r="56" cx="70" cy="70" />

            <circle class="progress-ring__progress" stroke-width="14" r="56" cx="70" cy="70"
              [attr.stroke-dasharray]="circumference" [attr.stroke-dashoffset]="dashOffset" />
          </svg>
          <div class="progress-text">
            <span class="percent">{{ scorePercentage }}%</span>
            <span class="label">Score</span>
          </div>
        </div>

        <div class="stats-grid" *ngIf="studentResult as studentPerformance">
          <div class="stat-card total">
            <div class="stat-header">
              <img src="assets/images/total-question.svg" alt="Total Questions" />
              <h4>{{studentPerformance.overall_user_performance.total_number_of_question}}</h4>
            </div>
            <p>Total Questions</p>
          </div>

          <div class="stat-card not-answered">
            <div class="stat-header">
              <img src="assets/images/not-ans.svg" alt="Not Answered" />
              <h4>{{studentPerformance.overall_user_performance.total_number_of_skipped_answer}}</h4>
            </div>
            <p>Not Answered</p>
          </div>

          <div class="stat-card correct">
            <div class="stat-header">
              <img src="assets/images/crt-ans.svg" alt="Correct Answers" />
              <h4>{{studentPerformance.overall_user_performance.total_number_of_correct_answer}}</h4>
            </div>
            <p>Correct Answer</p>
          </div>

          <div class="stat-card wrong">
            <div class="stat-header">
              <img src="assets/images/cancel.svg" alt="Wrong Answers" />
              <h4>{{studentPerformance.overall_user_performance.total_number_of_incorrect_answer}}</h4>
            </div>
            <p>Wrong Answer</p>
          </div>

          <div class="stat-card partial-correct">
            <div class="stat-header">
              <img src="assets/images/partial.svg" alt="partial Answers" />
              <h4>{{studentPerformance.overall_user_performance.total_number_of_partial_correct_answer}}</h4>
            </div>
            <p>Partially Answer</p>
          </div>
        </div>

      </div>
    </div>


    <div class="content">
      <h2 style="text-align: left;">Detailed Solutions</h2>

      <div class="question-nav" *ngIf="studentResult as studentDetails">
        <span *ngFor="let questionNo of studentDetails.quiz_conversation;let i = index" class="qbox bg mb-2" [ngClass]="{
		'correct':questionNo.evaluation.answer_type === QuizEvaluationType.Correct,
		'incorrect':questionNo.evaluation.answer_type === QuizEvaluationType.InCorrect,
		 'partial':questionNo.evaluation.answer_type === QuizEvaluationType.Partial,
		'not-answered':questionNo.is_skipped }" (click)="scrollToQuestion(i)"> {{ i +1}}</span>
      </div>
      <div class="questions">

        <div *ngIf="studentResult as studentQuestions">
          <div *ngFor="let studentQuestionName of studentQuestions.quiz_conversation; let i=index"
            class="question-section" [id]="'question-' + i" [class.highlighted]="selectedQuestionIndex === i">

            <div class="question-section">
              <div class="question-text">
                <div class="q-left">
                  <strong>
                    Q {{ i+ 1}}
                  </strong>
                  {{studentQuestionName.questions.question_text || '-'}}
                </div>
                <div class="q-right">
                  <span class="tag" [ngClass]="{
            'correct': studentQuestionName.evaluation.answer_type === QuizEvaluationType.Correct,
            'incorrect': studentQuestionName.evaluation.answer_type === QuizEvaluationType.InCorrect,
			'partial':studentQuestionName.evaluation.answer_type === QuizEvaluationType.Partial,
            'not-answered': studentQuestionName.is_skipped}">
                    {{studentQuestionName.is_skipped ? 'Not Answer' : (studentQuestionName.evaluation.answer_type |
                    titlecase)}}
                  </span>
                </div>
              </div>

              <div class="options"
                *ngIf="studentQuestionName.questions.question_type  === QuizQuestionType.MCQ || studentQuestionName.questions.question_type === QuizQuestionType.TRUE_FALSE">
                <label class="custom-radio" *ngFor="let option of studentQuestionName.questions.options" [ngClass]="{
          'correct-option': option.text === studentQuestionName.questions.correct_answer,
          'user-incorrect': option.text === studentQuestionName.user_answer && option.text !==
		   studentQuestionName.questions.correct_answer}">

                  <input type="radio" [checked]="option.text ===studentQuestionName.user_answer" disabled />
                  <span class="radio-check"></span>
                  <span class="option-text">{{option.text ||'-'}}</span>

                  <span class="answer-status correct"
                    *ngIf="option.text === studentQuestionName.user_answer && option.text === studentQuestionName.questions.correct_answer">
                    Your Answer
                  </span>
                  <span class="answer-status incorrect"
                    *ngIf="option.text === studentQuestionName.user_answer && option.text !== studentQuestionName.questions.correct_answer">
                    Your Answer
                  </span>
                  <span class="answer-status correct"
                    *ngIf="option.text === studentQuestionName.questions.correct_answer && option.text !== studentQuestionName.user_answer">
                    Correct Answer
                  </span>
                </label>
              </div>
            </div>

            <div class="open-ended-answers"
              *ngIf="studentQuestionName.questions.question_type === QuizQuestionType.OPEN_ENDED">

              <div class="answer-box partial-answered-box" *ngIf="studentQuestionName.user_answer && 
		   studentQuestionName.evaluation.answer_type === QuizEvaluationType.Partial">
                <div class="answer-label">Your Answer (Partially Correct):</div>
                <div class="answer-content">{{studentQuestionName.user_answer}}</div>
              </div>

              <div class="answer-box user-answer-box" *ngIf="studentQuestionName.user_answer
		  && studentQuestionName.evaluation.answer_type === QuizEvaluationType.InCorrect">
                <div class="answer-label"> Your Answer:</div>
                <div class="answer-content">{{studentQuestionName.user_answer || '-'}}</div>
              </div>

              <div class="answer-box correct-answer-box">
                <div class="answer-label">Correct Answer:</div>
                <div class="answer-content">{{studentQuestionName.questions.correct_answer || '-'}}</div>
              </div>
            </div>

            <div class="explanation mb-3"><strong>Explanation:</strong> {{studentQuestionName.evaluation.review || '-'}}
            </div>
            <div class="feedback mb-5"><strong>Feedback:</strong> {{studentQuestionName.evaluation.feedback || '-'}}
            </div>
          </div>
        </div>


        <h6 class="insight d-flex justify-content-start">Performance Insights</h6>
        <div class="performance" *ngIf="studentResult as studentAreaPerformance">

          <div class="strong">
            <h4><img src="assets/images/moving.svg" alt="Submit Icon" height="20" class="me-1" />Strong Areas</h4>
            <div class="tags">
              <span class="strongspan"
                *ngFor="let studentArea of studentAreaPerformance.overall_user_performance.strong_areas">
                {{studentArea|| '-'}}
              </span>
            </div>
          </div>
          <div class="weak">
            <h4><img src="assets/images/target.svg" alt="Submit Icon" height="20" />Areas for Improvement</h4>
            <div class="tags">
              <span class="weakspan"
                *ngFor="let studentWeak of studentAreaPerformance.overall_user_performance.areas_for_improvement">
                {{studentWeak || '-'}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</ng-template>